import { commercialListApi, propertyDetailApi, residentialListApi } from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { propertyActions } from "./actions";

export function* propertySaga() {
    yield takeEveryFsa(propertyActions.getCommercialList.started, function* (action) {
        yield* makeAsyncApiCall(action, propertyActions.getCommercialList, commercialListApi);
    });

    yield takeEveryFsa(propertyActions.getResidentailList.started, function* (action) {
        yield* makeAsyncApiCall(action, propertyActions.getResidentailList, residentialListApi);
    });

    yield takeEveryFsa(propertyActions.propertyDetail.started, function* (action) {
        yield* makeAsyncApiCall(action, propertyActions.propertyDetail, propertyDetailApi);
    })
}
